import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';
import Typography from '../../Typography';
import { ModalImageContainerWithText } from '../../ImageContainer/ModalImageContainer';
import App from '../../../../models/app';

const UninstallContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 16px;
`;

const TileContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 8px 0px;
`;

const mapStateToProps = (state: any) => {
  const {
    installedTiles
  } = state.registry;

  let tiles = [];
  if (installedTiles && Object.keys(installedTiles).length > 0) {
    tiles = Object.keys(installedTiles).map((tileId: any) => App.selectFromState(tileId, state));
  }

  return {
    tiles
  }
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface UninstallModalProps extends ModalProps, ReduxProps { }

const UninstallModal: FC<UninstallModalProps> = ({ app, tiles, deviceName, onCancel, onSuccess }) => {
  const ownTiles = tiles.filter((tile) => tile.parentApp?.id === app.id);

  return (
    <Dialog
      show={true}
      id="UninstallModal"
      title={i18n('component.UninstallModal.Title')({ appName: app.name })}
      onDismiss={onCancel}
      actions={[
        {
          text: i18n('component.UninstallModal.CancelText')(),
          onClick: onCancel,
          variant: 'text',
          id: 'uninstall-button-cancel'
        },
        {
          text: i18n('component.UninstallModal.UninstallText')(),
          onClick: onSuccess,
          variant: 'filled',
          id: 'uninstall-button-ok'
        }
      ]}
    >
      <UninstallContentContainer>
        <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
          {i18n('component.UninstallModal.Content')()}
        </Typography>
        {ownTiles && ownTiles.length > 0 && (
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography
              variant="titleSmallEmphasized"
              color="var(--sys-color--on-surface)"
            >
              {i18n('component.UninstallModal.TilesText')()}
            </Typography>
            {ownTiles.map((tile: any) => (
              <TileContainer key={tile.id}>
                <ModalImageContainerWithText
                  app={tile}
                  text={tile.name}
                  subtext={tile.developer.name}
                  deviceName={deviceName}
                />
              </TileContainer>
            ))}
          </div>
        )}
      </UninstallContentContainer>
    </Dialog>
  );
};

export default connect(mapStateToProps, null)(UninstallModal);
